import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [storefront, setStorefront] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("drelik_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setStorefront(data.storefront);
    } catch {
      localStorage.removeItem("drelik_token");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const applyAuth = (data) => {
    localStorage.setItem("drelik_token", data.token);
    setUser(data.user);
    setStorefront(data.storefront);
    return data;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return applyAuth(data);
  };

  const registerOwner = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return applyAuth(data);
  };

  const registerCustomer = async (payload) => {
    const { data } = await api.post("/auth/customer-register", payload);
    return applyAuth(data);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("drelik_token");
    setUser(false);
    setStorefront(null);
  };

  return (
    <AuthContext.Provider value={{ user, storefront, loading, login, registerOwner, registerCustomer, logout, refresh, setStorefront }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
